import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../InputForm';
import useNotificacionesStore from '../../store/notificacionesStore';
import SelectForm from '../SelectForm';

const FormNotificaciones = () => {
    const navigate = useNavigate();
    const [disabledButton, setDisabledButton] = useState(false)
    const goBack = () => {
        navigate(-1);
    };

    const { datos, handleChange, handleSave, error, tipos_notificacion, sucursales, preferencias, dispositivos } = useNotificacionesStore();

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <InputForm
                        name="titulo"
                        label="Titulo"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        name="subtitulo"
                        label="Subtitulo"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>

                    <SelectForm
                        name='tipo_notificacion'
                        label='Tipo de notificación'
                        datos={datos}
                        change={handleChange}
                        options={tipos_notificacion}
                    />

                    {
                        datos.tipo_notificacion == 3 &&
                        <SelectForm
                            name='id_sucursal'
                            label='Sucursal'
                            datos={datos}
                            change={handleChange}
                            options={sucursales}
                            error={error}
                        />
                    }

                    {
                        datos.tipo_notificacion == 4 &&
                        <SelectForm
                            name='id_preferencia'
                            label='Preferencia'
                            datos={datos}
                            change={handleChange}
                            options={preferencias}
                            error={error}
                        />
                    }

                    {
                        datos.tipo_notificacion == 5 &&
                        <SelectForm
                            name='tipo_dispositivo'
                            label='Tipo de dispositivo'
                            datos={datos}
                            change={handleChange}
                            options={dispositivos}
                            error={error}
                        />
                    }
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <button
                            onClick={goBack}
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                            Cancelar
                        </button>
                        <button
                            // type="submit"
                            disabled={disabledButton}
                            onClick={
                                () => {
                                    // setDisabledButton(true);
                                    handleSave();
                                }
                            }
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FormNotificaciones;